import styled from 'styled-components';
import { space, MarginProps } from 'styled-system';

const MarginButton = styled.button<MarginProps>(space);

export default MarginButton;
